import styled from 'styled-components';
import { Form } from '@thinknet-gmbh/platform-common-ui';

export const EauFormWrapper = styled(Form)`
  .upload-file-field {
    width: 100%;
    max-width: 100%;
    button {
      width: 100%;
      display: flex;
      justify-content: center;
      min-height: 32px;
    }
  }
`;

export const LabelFileInfo = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.tone.lightBlue};

  svg {
    cursor: pointer;
  }
`;
